import { render, staticRenderFns } from "./TransferMoney.vue?vue&type=template&id=3e16b60e&scoped=true&"
import script from "./TransferMoney.vue?vue&type=script&lang=js&"
export * from "./TransferMoney.vue?vue&type=script&lang=js&"
import style0 from "./TransferMoney.vue?vue&type=style&index=0&id=3e16b60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16b60e",
  null
  
)

export default component.exports